import * as Config from '../../../../config';
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from 'dayjs';

import PopupCTA from '../PopupCTA';
import PopupContent from '../PopupContent';
import PopupButton from '../PopupButton';

import AutomixTip from '../media/automix.png';
import CartTip from '../media/cart.png';
import AudioTip from '../media/audio.png';
import PlaylistTip from '../media/playlist.png';
import ControllerTip from '../media/controller.png';
import TrackTip from '../media/track.png';
import RecommendationTip from '../media/recommendation.png';
import B2BTip from '../media/b2b.png';
import FollowTip from '../media/follow.png';
import TransferTip from '../media/transfer.png';
import DesktopTip from '../media/desktop.png';
import ShortcutTip from '../media/shortcut.png';
import MarketingTip from '../media/marketing.png';

import {
  setPopup, setStorePopup,
  patchEndpoint
} from "../../../../actions/index"

let timeoutEvent = null;
const usePopupManagement = () => {
  const user = useSelector( state => state.user );
  const isSubscribed = useSelector( state => state.isSubscribed );
  const storeAuth = useSelector(state => state.storeAuth);
  const dispatch = useDispatch();
  const data = JSON.parse(localStorage.getItem('NcJjy5P2M6'));
  const f_newsletter = true; // JSON.parse(localStorage.getItem('f_newsletter'));
  const isNewAccount = !!localStorage.getItem('new_account'); // TEST

  const eventClickPreview = () => { preview(); }
  useEffect(() => {
    if (user) {
      if (timeoutEvent) {
        clearTimeout(timeoutEvent);
      }
      if (user.type && user.type !== null) {
        const previewDeckA = document.getElementById('jump1_preview');
        if (previewDeckA) {
          previewDeckA.outerHTML = document.getElementById('jump1_preview').outerHTML;
        }
        const previewDeckB = document.getElementById('jump2_preview');
        if (previewDeckB) {
          previewDeckB.outerHTML = document.getElementById('jump2_preview').outerHTML;
        }
      }

      // NEWSLETTERS OPT-INS
      const blockMarketing = (next = null) => {
        const disablePopup = () => { dispatch(setPopup({ content: null })); };
        const update = (enable = false) => () => {
          if (enable) {
            dispatch(patchEndpoint('/my/email-preferences/', {
              opt_in_offers: "True",
              opt_in_happenings: "True",
              opt_in_content: "True",
              opt_in_store: "True",
              opt_in_stream: "True",
              opt_in_hype: "True",
              opt_in_beatportal: "True",
              opt_in_loopmasters: "True" 
            }));
          }
          
          localStorage.setItem('f_newsletter', JSON.stringify(dayjs()) );
          localStorage.removeItem('new_account'); // TEST
          if (next) { 
            next(); 
          } else {
            disablePopup();
          }
        }

        dispatch(setPopup({ content: (
          <PopupCTA title={`Stay connected with Beatport`} media={MarketingTip} mediaClassName={'no-fixed-height'}>
            <PopupContent>
              <span>Receive emails about new music, product education, exclusive offers, and other updates from the Beatport Group. Unsubscribe at anytime on Beatport.com</span>
            </PopupContent>
            <PopupButton label={`Yes, send me email updates`} className={'pb-primary pb-newsletter'} onClick={update(true)} />
            <PopupButton label={`No, I don't want updates`} onClick={update(false)} />
          </PopupCTA>
        ), className: 'full-center', outsideClick: false }));
      }

      // BLOCK 1
      if (data === null || (data && data.c === 0)) {
        const block1tip3 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Uncover track inspiration`} media={TrackTip} indexClass={'thirdTip'}>
              <PopupContent>
                <span>Explore our curated, handpicked Dig Deeper playlists.</span>
              </PopupContent>
              <PopupButton label={`Start Digging`} className={'pb-primary pb-first'} />
            </PopupCTA>
          ), className: 'full-center' }));
        }

        const block1tip2 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Mix directly on your controller`} media={ControllerTip} indexClass={'secondTip'}>
              <PopupContent>
                <span>Connect your DJ hardware and begin mixing from a catalog of 12 million tracks. <a href={'https://www.youtube.com/watch?si=2nVz1OAeDnE4Cwar&v=K25gJ0lTAMc&feature=youtu.be'} target={'_blank'} rel="noopener noreferrer">Watch video tutorial</a>.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'} onClick={block1tip3}  />
            </PopupCTA>
          ), className: 'full-center' }));
        }

        const block1tip1 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`The ultimate discovery tool`} media={AutomixTip} indexClass={'firstTip'}>
              <PopupContent>
                <span>Find the latest tracks effortlessly, refining your track selection process.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'} onClick={block1tip2}  />
            </PopupCTA>
          ), className: 'full-center' }));
        }

        // BLOCK 1 Tips
        if (!user.hasNewsletterOptIns && (!f_newsletter || isNewAccount) && Config.APP_NAME === 'beatport') {
          setTimeout(() => { blockMarketing(block1tip1); }, 100);
        } else {
          setTimeout(() => { block1tip1(); }, 100)
        }

        const state = data ? data : {d : null, c: 0, g: 0};
        state.c = 1;
        localStorage.setItem('NcJjy5P2M6', JSON.stringify(state) );
      }
      else if (data && data.c === 1) { // BLOCK 2
        const block2tip3 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Advanced playlist management`} media={PlaylistTip} indexClass={'thirdTip'}>
              <PopupContent>
                <span>Manage music effortlessly by dragging and dropping or utilizing keyboard shortcuts.</span>
              </PopupContent>
              <PopupButton label={`Start Digging`} className={'pb-primary pb-first'} />
            </PopupCTA>
          ), className: 'full-center' }));
        }
  
        const block2tip2 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Find your next favorite track`} media={RecommendationTip} indexClass={'secondTip'}>
              <PopupContent>
                <span>Click any track title to explore personalized music recommendations.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'} onClick={block2tip3} />
            </PopupCTA>
          ), className: 'full-center' }));
        }
  
        const block2tip1 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`DJ with millions of tracks`} media={AudioTip} indexClass={'firstTip'}>
              <PopupContent>
                <span>Mix from the finest electronic music catalog with full-track playback in high quality audio.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'}  onClick={block2tip2} />
            </PopupCTA>
          ), className: 'full-center' }));
        }

        // BLOCK 2 Tips
        if (!user.hasNewsletterOptIns && (!f_newsletter || isNewAccount) && Config.APP_NAME === 'beatport') {
          setTimeout(() => { blockMarketing(block2tip1); }, 100);
        } else {
          setTimeout(() => { block2tip1(); }, 100)
        }

        const state = data;
        state.c = 2;
        localStorage.setItem('NcJjy5P2M6', JSON.stringify(state) );
      }
      else if (data && data.c === 2) { // BLOCK 3
        const block3tip3 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Shortcut to success`} media={ShortcutTip} indexClass={'thirdTip'}>
              <PopupContent>
                <span>Press Shift + ? for a list of keyboard shortcuts designed to enhance your workflow.</span>
              </PopupContent>
              <PopupButton label={`Start Digging`} className={'pb-primary pb-first'} />
            </PopupCTA>
          ), className: 'full-center' }));
        }
  
        const block3tip2 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Don't miss a beat`} media={FollowTip} indexClass={'secondTip'}>
              <PopupContent>
                <span>Follow your favorite artists and labels for a personalized music feed in My Beatport.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'} onClick={block3tip3} />
            </PopupCTA>
          ), className: 'full-center' }));
        }
  
        const block3tip1 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Buy tracks while digging`} media={CartTip} indexClass={'firstTip'}>
              <PopupContent>
                <span>Purchase music seamlessly as you dive into your musical journey.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'} onClick={block3tip2} />
            </PopupCTA>
          ), className: 'full-center' }));
        }

        // BLOCK 3 Tips
        if (!user.hasNewsletterOptIns && (!f_newsletter || isNewAccount) && Config.APP_NAME === 'beatport') {
          setTimeout(() => { blockMarketing(block3tip1); }, 100);
        } else {
          setTimeout(() => { block3tip1(); }, 100)
        }

        const state = data;
        state.c = 3;
        localStorage.setItem('NcJjy5P2M6', JSON.stringify(state) );
      }
      else if (data && data.c === 3) { // BLOCK 4
        const block4tip3 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Instant desktop access`} media={DesktopTip} indexClass={'thirdTip'}>
              <PopupContent>
                <span>Launch Beatport DJ directly from your desktop using our Chrome shortcut.</span>
              </PopupContent>
              <PopupButton label={`Start Digging`} className={'pb-primary pb-first'} />
            </PopupCTA>
          ), className: 'full-center' }));
        }
  
        const block4tip2 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Transfer and mix your music`} media={TransferTip} indexClass={'secondTip'}>
              <PopupContent>
                <span>Import your favorite playlists in just a few clicks using <a href={'https://soundiiz.com/partner/beatport'} target={'_blank'} rel="noopener noreferrer">Soundiiz</a> and <a href={'https://www.tunemymusic.com/transfer?mode=beatport'} target={'_blank'} rel="noopener noreferrer">TuneMyMusic</a>.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'}  onClick={block4tip3} />
            </PopupCTA>
          ), className: 'full-center' }));
        }
  
        const block4tip1 = () => {
          dispatch(setPopup({ content: (
            <PopupCTA title={`Discover tracks with friends`} media={B2BTip} indexClass={'firstTip'}>
              <PopupContent>
                <span>Connect with users around the world for a mix in B2B Mode.</span>
              </PopupContent>
              <PopupButton label={`Next`} className={'pb-primary pb-first'} onClick={block4tip2} />
            </PopupCTA>
          ), className: 'full-center' }));
        }

        // BLOCK 4 Tips
        if (!user.hasNewsletterOptIns && (!f_newsletter || isNewAccount) && Config.APP_NAME === 'beatport') {
          setTimeout(() => { blockMarketing(block4tip1); }, 100);
        } else {
          setTimeout(() => { block4tip1(); }, 100)
        }
       
        const state = data;
        state.c = 4;
        localStorage.setItem('NcJjy5P2M6', JSON.stringify(state) );
      } 
      else if (!user.hasNewsletterOptIns && (!f_newsletter || isNewAccount) && Config.APP_NAME === 'beatport') {
        setTimeout(() => { blockMarketing(); }, 100);
      }

      // DEPRECATED - DISABLE
      // if (data && user.email) { // Connected 10min Session - Once every 6 months
      //   let diff = null;
      //   if (data.d) {
      //     const today = dayjs();
      //     const init = dayjs(data.d);
      //     diff = today.diff(init, 'month');
      //   }
      //   if (/*diff >= 6 || */diff === null) { // Only one time
      //     setTimeout(() => {
      //       dispatch(setPopup({ content: (
      //         <PopupCTA title={`Win a $10 ${Config.capAppName()}.com credit`} style={{minHeight: 0}}>
      //           <PopupContent>
      //             <span>Take a one-minute survey for a chance to win in our bi-monthly sweepstake.</span>
      //           </PopupContent>
      //           <PopupButton label={`Start Survey`} className={'pb-primary pb-first'} closeAuto={true} onClick={() => { window.open(`https://research.beatport.com/jfe/form/SV_6rOn7DOUCbZXtZk?email=${user.email}&first_name=${user.firstname}&account_type=${user.type ? user.type : 'free_account'}`) }} />
      //           <PopupButton label={`No Thanks`} />
      //         </PopupCTA>
      //       ), className: 'full-center' }));
      //       const state = data;
      //       state.d = dayjs();
      //       localStorage.setItem('NcJjy5P2M6', JSON.stringify(state) );
      //     }, 600000)
      //   }
      // }
    } else {
      const previewDeckA = document.getElementById('jump1_preview');
      if (previewDeckA) {
        previewDeckA.addEventListener(`click`, eventClickPreview, false)
      }
      const previewDeckB = document.getElementById('jump2_preview');
      if (previewDeckB) {
        previewDeckB.addEventListener(`click`, eventClickPreview, false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, dispatch])
 
  const buzz = (selector) => {
    if (selector) {
      setTimeout(() => {
        const button = document.querySelector(selector);
        if (button) {
          button.classList.add("buzz-out");
          setTimeout(() => {
            button.classList.remove("buzz-out");
          }, 1000)
        }
      }, 50)
    }
  }

  const playlist = (selector = null) => { // Playlist / Add to playlist Click
    dispatch(setPopup({ content: (
      <PopupCTA title={`Create a free account to access your playlists`}>
        <PopupContent>
          <span>To create a playlist on your digging journey, you need a free {Config.capAppName()} account. It’s simple and takes a few clicks.</span>
        </PopupContent>
        <div className={'popupv2-group-buttons flexRow center'}>
          <PopupButton label={`Sign Up`} className={'pb-primary'} onClick={() => { storeAuth.registration() }} />
          <PopupButton label={`Log In`} className={'pb-second'} onClick={() => { storeAuth.signin() }} />
        </div>
        <PopupButton label={`No Thanks`} />
      </PopupCTA>
    ), className: 'popup-side' }));
    buzz(selector);
  }

  const cart = (selector = null) => { // Cart / Add to cart Click
    dispatch(setPopup({ content: (
      <PopupCTA title={`Create a free account to access your cart`}>
        <PopupContent>
          <span>To purchase tracks and view your cart, you need a free {Config.capAppName()} account. It’s simple and takes a few clicks.</span>
        </PopupContent>
        <div className={'popupv2-group-buttons flexRow center'}>
          <PopupButton label={`Sign Up`} className={'pb-primary'} onClick={() => { storeAuth.registration() }} />
          <PopupButton label={`Log In`} className={'pb-second'} onClick={() => { storeAuth.signin() }} />
        </div>
        <PopupButton label={`No Thanks`} />
      </PopupCTA>
    ), className: 'popup-side' }));
    buzz(selector);
  }

  const myBeatport = () => {  // My Beatport Click
    dispatch(setPopup({ content: (
      <PopupCTA title={`Create a free account to access My Beatport`}>
        <PopupContent>
          <span>To receive personalized music in My Beatport, you need a free {Config.capAppName()} account. It’s simple and takes a few clicks.</span>
        </PopupContent>
        <div className={'popupv2-group-buttons flexRow center'}>
          <PopupButton label={`Sign Up`} className={'pb-primary'} onClick={() => { storeAuth.registration() }} />
          <PopupButton label={`Log In`} className={'pb-second'} onClick={() => { storeAuth.signin() }} />
        </div>
        <PopupButton label={`No Thanks`} />
      </PopupCTA>
    ), className: 'popup-side' }));
  }

  const follow = (selector = null) => { // Follow Click
    dispatch(setPopup({ content: (
      <PopupCTA title={`Create a free account to follow your favorite artists and labels`}>
        <PopupContent>
          <span>To follow your favorite artists and labels, you need a free {Config.capAppName()} account. It’s simple and takes a few clicks.</span>
        </PopupContent>
        <div className={'popupv2-group-buttons flexRow center'}>
          <PopupButton label={`Sign Up`} className={'pb-primary'} onClick={() => { storeAuth.registration() }} />
          <PopupButton label={`Log In`} className={'pb-second'} onClick={() => { storeAuth.signin() }} />
        </div>
        <PopupButton label={`No Thanks`} />
      </PopupCTA>
    ), className: 'popup-side' }));
    buzz(selector);
  }

  const collection = () => { // Collection Click
    dispatch(setPopup({ content: (
      <PopupCTA title={`Create a free account to access your collection`}>
        <PopupContent>
          <span>To playback tracks purchased from {Config.capAppName()}.com, you need a free {Config.capAppName()} account. It’s simple and takes a few clicks.</span>
        </PopupContent>
        <div className={'popupv2-group-buttons flexRow center'}>
          <PopupButton label={`Sign Up`} className={'pb-primary'} onClick={() => { storeAuth.registration() }} />
          <PopupButton label={`Log In`} className={'pb-second'} onClick={() => { storeAuth.signin() }} />
        </div>
        <PopupButton label={`No Thanks`} />
      </PopupCTA>
    ), className: 'popup-side' }));
  }

  const preview = () => { // Outside Preview Click
    if (!isSubscribed) {
      dispatch(setPopup({ content: (
        <PopupCTA title={`Would you like to play the full-track?`}>
          <PopupContent>
            <span>Sign up for the Essential plan and gain access to over 12 million tracks, including full-track playback in high-quality audio.</span>
          </PopupContent>
          <PopupButton label={`Try ${Config.capAppName()} Streaming for free`} className={'pb-primary side-pb-first'} onClick={() => { window.open(Config.REDIRECT_TRIAL) }} />
          <PopupButton label={`I don't want to play the full-track`} />
        </PopupCTA>
      ), className: 'popup-side' }));
    }
  }

  const b2b = () => { // B2B Mode Click 
    dispatch(setPopup({ content: (
      <PopupCTA title={`Ready to try B2B Mode?`}>
        <PopupContent>
          <span>Sign up for the Essential plan and gain access to over 12 million tracks, including B2B Mode and full-track playback in high-quality audio.</span>
        </PopupContent>
        <PopupButton label={`Try ${Config.capAppName()} Streaming for free`} className={'pb-primary side-pb-first'} onClick={() => { window.open(Config.REDIRECT_TRIAL) }} />
        <PopupButton label={`I am not interested in trying B2B Mode`} />
      </PopupCTA>
    ), className: 'popup-side' }));
  }

  const automix = (selector = null) => { // Automix Click
    dispatch(setPopup({ content: (
      <PopupCTA title={`Automix is better with full-track playback`}>
        <PopupContent>
          <span>Sign up for the Essential plan and gain access to over 12 million tracks, including high-quality audio playback of full-tracks when using Automix.</span>
        </PopupContent>
        <PopupButton label={`Try ${Config.capAppName()} Streaming for free`} className={'pb-primary side-pb-first'} onClick={() => { window.open(Config.REDIRECT_TRIAL) }} />
        <PopupButton label={`I don't want to play the full-track`} />
      </PopupCTA>
    ), className: 'popup-side' }));
    buzz(selector);
  }


  const noPlaylistTransfert = (onClick) => {
    const disablePopup = () => { dispatch(setPopup({ content: null })); };
    dispatch(setPopup({ content: (
      <PopupCTA title={`Transfer and mix your music`} media={TransferTip}>
        <PopupContent>
          <span>Import your favorite playlists in just a few clicks using <a onClick={() => { disablePopup() }} href={'https://soundiiz.com/partner/beatport'} target={'_blank'} rel="noopener noreferrer">Soundiiz</a> and <a onClick={() => { disablePopup() }} href={'https://www.tunemymusic.com/transfer?mode=beatport'} target={'_blank'} rel="noopener noreferrer">TuneMyMusic</a>.</span>
        </PopupContent>
        <PopupButton label={`No Thanks`} className={'pb-second'} style={{opacity:0.5}} onClick={onClick} closeAuto={true} />
      </PopupCTA>
    ), className: 'full-center' }));
  }


  const store = { playlist, cart, myBeatport, follow, collection, preview, b2b, automix, noPlaylistTransfert };
  setTimeout(() => { dispatch(setStorePopup(store)) }, 100);

  return null;
}

export default usePopupManagement;
